import React, { useEffect, useState } from "react";
import ChessBoard from "../RenderChessBoard/ChessBoard";
import ChessCP from "./ChessCP";
import GetChessBoard from "../ReusableParts/GetChessBoard";
import NQueens from "./Logic";
import { FaChessQueen } from "react-icons/fa";
type Props = {};

function NQueen({}: Props) {
  const [clear, setClear] = useState<Boolean>(false);
  const [boardSize, setBoardSize] = useState(10);
  const [Board, setBoard] = useState(GetChessBoard(boardSize));
  const [progressSpeed, setProgressSpeed] = useState<number>(5);
  const [progress, setProgress] = useState<number>(0);
  const [startSolving, setStartSolving] = useState<Boolean>(false);
  let solved: Boolean[][] = [[]];
  const SolveNQueen = async () => {
    const solved = NQueens(16, Board);
    let processed = solved.processed;
    const len = processed.length;
    let i = 0;
    for (const grid of processed) {
      if (clear) {
        processed = [];
        setClear(false);
        break;
      }
      setBoard(grid);
      setProgress((100 * i) / len);
      i++;
      await new Promise((__) => setTimeout(__, progressSpeed));
    }
  };
  useEffect(() => {
    startSolving && SolveNQueen();
    clear && setBoard(GetChessBoard(boardSize));
  }, [startSolving, clear]);
  useEffect(() => {
    setBoard(GetChessBoard(boardSize));
  }, [boardSize]);
  return (
    <div className="Sudoku">
      <ChessBoard Board={Board} />
      <ChessCP
        setStartSolving={setStartSolving}
        setProgressSpeed={setProgressSpeed}
        setClear={setClear}
        setBoardSize={setBoardSize}
      />
    </div>
  );
}

export default NQueen;
